/**
 * Resolve the public web-app (platform) base URL for building links
 * from the CMS (e.g. deep links into community, dashboard, etc.).
 *
 * Resolution order:
 *   1. `REACT_APP_PLATFORM_BASE_URL` (preferred, per-env).
 *   2. `REACT_APP_NODE_ENV` heuristic for stage/development builds.
 *   3. Production default.
 */
const PRODUCTION_BASE_URL = "https://app.myneurogym.com"
const STAGE_BASE_URL = "https://stage.app.myneurogym.com"

export function getPlatformBaseUrl() {
  const explicit = (process.env.REACT_APP_PLATFORM_BASE_URL || "").trim()
  if (explicit) return explicit.replace(/\/+$/, "")

  const env = String(process.env.REACT_APP_NODE_ENV || "")
    .trim()
    .toLowerCase()
  if (env === "stage" || env === "development") return STAGE_BASE_URL
  return PRODUCTION_BASE_URL
}

export function buildPlatformUrl(path) {
  const base = getPlatformBaseUrl()
  if (!path) return base
  const normalizedPath = String(path).startsWith("/") ? path : `/${path}`
  return `${base}${normalizedPath}`
}

export function buildDashboardModalUrl(tag) {
  if (!tag) return ""
  return `${getPlatformBaseUrl()}/dashboard?modalTag=${encodeURIComponent(tag)}`
}

export function buildAppLaunchPopupPreviewUrl(day) {
  const dayNumber = Math.max(0, Number(day) || 0)
  const params = new URLSearchParams()
  params.set("forceAppLaunchPopupDay", String(dayNumber))
  return `${getPlatformBaseUrl()}/dashboard?${params.toString()}`
}

export function buildCommunityPostUrl(postId) {
  if (!postId) return ""
  return `${getPlatformBaseUrl()}/community/post/${postId}`
}
